import React from 'react'
import PropTypes from 'prop-types'

// styles for the preview
import 'assets/lib/styles/bootstrap-grid.min.css';
import 'assets/lib/styles/fontawesome/css/all.min.css';
import 'assets/lib/styles/slick.min.css';
import 'assets/lib/styles/slick-theme.min.css';

const PortalStyles = ({ children }) => (
  <>
    {children}
  </>
)

PortalStyles.propTypes = {
  children: PropTypes.node.isRequired,
}

export default PortalStyles
